// extracted by mini-css-extract-plugin
export default {"root":"pA9NN","title":"_kCW7","items":"nqdUT"};